import React from "react";
import { Product, SelectedProduct } from "~/common/Store/models/ProductListing";
import { UserState } from "~/common/Store/models/RootReadonly";
import EmailButton from "../Email/EmailButton";

interface EmailButtonWrapperProps {
  hasCustomizableProductsOverride: boolean;
  isCarouselProductBox: boolean;
  product: Product;
  selectedProduct: SelectedProduct;
  groupingValue: string;
  user: UserState;
}

const getOutOfStockItemNumber = (
  product: Product,
  selectedProduct: SelectedProduct,
  groupingValue: string,
): string => {
  const { grouping, groupingAttributes } = product;

  const hasInStockGroupingMembers =
    grouping &&
    groupingAttributes.groupMembers.some((members) => members.isInStock);

  // VG items have no master grouping item, so need to be handled differently
  if (groupingAttributes.isVirtual) {
    return hasInStockGroupingMembers
      ? selectedProduct.itemNumber
      : groupingValue;
  }

  return hasInStockGroupingMembers
    ? selectedProduct.itemNumber
    : product.itemNumber;
};

const EmailButtonWrapper = ({
  hasCustomizableProductsOverride,
  isCarouselProductBox,
  product,
  selectedProduct,
  groupingValue,
  user,
}: Readonly<EmailButtonWrapperProps>) => {
  const shouldDisplayOutOfStockEmail =
    !selectedProduct.isInStock &&
    !product.isReplacementEligible &&
    !isCarouselProductBox &&
    !hasCustomizableProductsOverride;

  return (
    <>
      {shouldDisplayOutOfStockEmail && (
        <EmailButton
          product={product}
          itemNumber={getOutOfStockItemNumber(
            product,
            selectedProduct,
            groupingValue,
          )}
          user={user}
        />
      )}
    </>
  );
};

export default EmailButtonWrapper;
